import { useTranslation } from 'react-i18next';
import { ControlPointDuplicate as ControlPointDuplicateIcon } from '@mui/icons-material';

import {
  ActionButton,
  ActionIconButton,
  MainActionButton,
  type ActionButtonProps,
  type ActionIconButtonProps,
  type MainActionButtonProps,
} from '@/components/buttons';

export type DuplicateMainActionButtonProps = MainActionButtonProps;

export const DuplicateMainActionButton = (props: DuplicateMainActionButtonProps) => {
  const { t } = useTranslation('actions');

  const { children = t('duplicate') } = props;

  return (
    <MainActionButton startIcon={<ControlPointDuplicateIcon fontSize="small" />} {...props}>
      {children}
    </MainActionButton>
  );
};

export type DuplicateActionButtonProps = ActionButtonProps;

export const DuplicateActionButton = (props: DuplicateActionButtonProps) => {
  const { t } = useTranslation('actions');
  const { children = t('duplicate') } = props;

  return (
    <ActionButton startIcon={<ControlPointDuplicateIcon fontSize="small" />} {...props}>
      {children}
    </ActionButton>
  );
};

export type DuplicateActionIconButtonProps = ActionIconButtonProps;

export const DuplicateActionIconButton = (props: DuplicateActionIconButtonProps) => {
  const { t } = useTranslation('actions');

  return (
    <ActionIconButton title={t('duplicate')} {...props}>
      <ControlPointDuplicateIcon fontSize="medium" />
    </ActionIconButton>
  );
};
